// This file was automatically generated from print.html.
// Please don't edit this file by hand.

goog.provide('el8.template.passport.print');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.passport.profile.meds');
goog.require('el8.template.passport.profile');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptImmunizationDeclines');
goog.require('el8.template.ptdata.ptImmunizations');
goog.require('el8.template.ptdata.ptIntolerances');
goog.require('el8.template.ptdata.ptProblems');
goog.require('el8.template.ptdata.ptProviders');
goog.require('el8.template.ptdata.smokingStatuses');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print.profile = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="pageHeaderContainer"><p class="italic">This Clinical Profile from Elation Health patient chart maintained by:</p>', (opt_data.primaryPhysician) ? '<p>' + soy.$$escapeHtml(opt_data.primaryPhysician.fullName) + ((opt_data.primaryPhysician.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.primaryPhysician.specialtyName) + ')' : '') + '</p>' : '', '<p>', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.address : ''), ', ', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.cityStateZip : ''), '</p><p>Office: ', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.phone : ''), ' | Fax: ', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.fax : ''), '</p></div>');
  el8.template.print.currentAsOf(opt_data, output);
  output.append('<h1 class="documentTitle">Clinical Profile</h1><h1>');
  el8.template.ptdata.patients.patientFacingName(opt_data.patient, output);
  output.append('</h1><table cellpadding="0" cellspacing="0" class="w100 mt10"><tr><td class="w22">Date Of Birth:</td><td>', soy.$$escapeHtml(opt_data.patient.dob), '</td></tr><tr><td class="w22">Primary Care Provider:</td><td>', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.fullName : ''), '</td></tr><tr><td class="w22">Last Appointment:</td><td>', (opt_data.lastSeenDate) ? (soy.$$escapeHtml(opt_data.lastSeenDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.lastSeenDate)) : '') : 'None', '</td></tr></table><h4>Allergies</h4>');
  if (opt_data.ptAllergies.items.length) {
    output.append('<ul class="list">');
    var paList179 = opt_data.ptAllergies.items;
    var paListLen179 = paList179.length;
    for (var paIndex179 = 0; paIndex179 < paListLen179; paIndex179++) {
      var paData179 = paList179[paIndex179];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptAllergies.summary(paData179, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="italic">');
    if (opt_data.ptAllergies.isDocumented) {
      el8.template.ptdata.ptAllergies.documentedAsNonePatientSummary(null, output);
    } else {
      el8.template.passport.profile.notDocumented(null, output);
    }
    output.append('</p>');
  }
  output.append('<h4>Drug Intolerances</h4>');
  if (opt_data.ptIntols.items.length) {
    output.append('<ul class="list">');
    var piList197 = opt_data.ptIntols.items;
    var piListLen197 = piList197.length;
    for (var piIndex197 = 0; piIndex197 < piListLen197; piIndex197++) {
      var piData197 = piList197[piIndex197];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptIntolerances.summary(piData197, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="italic">');
    if (opt_data.ptIntols.isDocumented) {
      el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    } else {
      el8.template.passport.profile.notDocumented(null, output);
    }
    output.append('</p>');
  }
  if (opt_data.ptProblems) {
    output.append('<h4>Problem List</h4>');
    if (opt_data.ptProblems.items.length) {
      output.append('<ol class="numberedList">');
      var ppList217 = opt_data.ptProblems.items;
      var ppListLen217 = ppList217.length;
      for (var ppIndex217 = 0; ppIndex217 < ppListLen217; ppIndex217++) {
        var ppData217 = ppList217[ppIndex217];
        output.append('<li class="preserve item">', soy.$$escapeHtml(ppData217.year), ' - ');
        el8.template.ptdata.ptProblems.summaryNoYear(ppData217, output);
        output.append('</li>');
      }
      output.append('</ul>');
    } else {
      output.append('<p class="italic">');
      if (opt_data.ptProblems.isDocumented) {
        el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
      } else {
        el8.template.passport.profile.notDocumented(null, output);
      }
      output.append('</p>');
    }
  }
  if (opt_data.historyItems) {
    output.append('<h4>History</h4>');
    if (! opt_data.historyItems.past.items.length && ! opt_data.historyItems.surgical.items.length && ! opt_data.historyItems.family.items.length && ! opt_data.historyItems.social.items.length && ! opt_data.historyItems.habits.items.length && ! opt_data.historyItems.diet.items.length && ! opt_data.historyItems.exercise.items.length && ! opt_data.historyItems.cognitive.items.length && ! opt_data.historyItems.functional.items.length && ! opt_data.currSmokingStatus && ! opt_data.familyRelationships.length) {
      output.append('<p class="italic">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    } else {
      output.append('<ul class="list">');
      el8.template.passport.print.rowsList({sectionTitle: 'Past Medical History', itemsList: opt_data.historyItems.past.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Past Surgical History', itemsList: opt_data.historyItems.surgical.items}, output);
      el8.template.passport.print.familyHistoryList(opt_data, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Social History', itemsList: opt_data.historyItems.social.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Cognitive', itemsList: opt_data.historyItems.cognitive.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Functional', itemsList: opt_data.historyItems.functional.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Habits', itemsList: opt_data.historyItems.habits.items}, output);
      if (opt_data.currSmokingStatus) {
        output.append('<li class="preserve itemBullet">Cigs: ');
        el8.template.ptdata.smokingStatuses.summary(opt_data.currSmokingStatus, output);
        output.append('</li>');
      }
      el8.template.passport.print.rowsList({sectionTitle: 'Diet', itemsList: opt_data.historyItems.diet.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Exercise', itemsList: opt_data.historyItems.exercise.items}, output);
      el8.template.passport.print.rowsList({sectionTitle: 'Health Maintenance', itemsList: opt_data.historyItems.maintenance.items}, output);
      output.append('</ul>');
    }
  }
  output.append('<h4>Permanent Rx Meds</h4>');
  if (opt_data.permRxThreads.length) {
    output.append('<ol class="numberedList">');
    el8.template.passport.profile.meds.permList({threads: opt_data.permRxThreads}, output);
    output.append('</ul>');
  } else {
    output.append('<p class="italic">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  output.append('<h4>Permanent OTC Meds</h4>');
  if (opt_data.permOtcThreads.length) {
    output.append('<ol class="numberedList">');
    el8.template.passport.profile.meds.permList({threads: opt_data.permOtcThreads}, output);
    output.append('</ul>');
  } else {
    output.append('<p class="italic">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  output.append('<h4>Immunizations</h4>');
  if (opt_data.ptImmunizations.items.length || opt_data.ptImmunizationDeclines.items.length || opt_data.historyItems && opt_data.historyItems.immunization.items.length) {
    output.append('<ul class="list">');
    var itemList303 = opt_data.ptImmunizations.items;
    var itemListLen303 = itemList303.length;
    for (var itemIndex303 = 0; itemIndex303 < itemListLen303; itemIndex303++) {
      var itemData303 = itemList303[itemIndex303];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptImmunizations.summary(itemData303, output);
      output.append('</li>');
    }
    var itemList308 = opt_data.ptImmunizationDeclines.items;
    var itemListLen308 = itemList308.length;
    for (var itemIndex308 = 0; itemIndex308 < itemListLen308; itemIndex308++) {
      var itemData308 = itemList308[itemIndex308];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptImmunizationDeclines.summary(itemData308, output);
      output.append('</li>');
    }
    if (opt_data.historyItems) {
      el8.template.passport.print.bulletedListContent({itemsList: opt_data.historyItems.immunization.items}, output);
    }
    output.append('</ul>');
  } else {
    output.append('<p class="italic">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  if (opt_data.legalReportSummaries || opt_data.historyItems) {
    output.append('<h4>Legal</h4>');
    if (opt_data.legalReportSummaries.length || opt_data.historyItems.legal.items.length) {
      output.append('<ul class="list">');
      var itemList328 = opt_data.legalReportSummaries;
      var itemListLen328 = itemList328.length;
      for (var itemIndex328 = 0; itemIndex328 < itemListLen328; itemIndex328++) {
        var itemData328 = itemList328[itemIndex328];
        output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(itemData328), '</li>');
      }
      if (opt_data.historyItems) {
        el8.template.passport.print.bulletedListContent({itemsList: opt_data.historyItems.legal.items}, output);
      }
      output.append('</ul>');
    } else {
      output.append('<p class="italic">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    }
  }
  if (opt_data.mainProviders) {
    output.append('<h4>Consulting Physicians</h4>');
    if (opt_data.mainProviders.length) {
      output.append('<ul class="list">');
      var itemList348 = opt_data.mainProviders;
      var itemListLen348 = itemList348.length;
      for (var itemIndex348 = 0; itemIndex348 < itemListLen348; itemIndex348++) {
        var itemData348 = itemList348[itemIndex348];
        output.append('<li class="preserve itemBullet">');
        el8.template.ptdata.ptProviders.summary(itemData348, output);
        output.append('</li>');
      }
      output.append('</ul>');
    } else {
      output.append('<p class="italic">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    }
  }
  if (opt_data.patient.primaryInsurance && opt_data.patient.primaryInsurance.isNonEmpty) {
    output.append('<h4>Insurance Information</h4>');
    el8.template.passport.print._insurance(opt_data.patient.primaryInsurance, output);
  }
  if (opt_data.patient.secondaryInsurance && opt_data.patient.secondaryInsurance.isNonEmpty) {
    output.append('<h4>Secondary Insurance</h4>');
    el8.template.passport.print._insurance(opt_data.patient.secondaryInsurance, output);
  }
  output.append((opt_data.patient.displayRace || opt_data.patient.displayEthnicity || opt_data.patient.preferredLanguageName) ? '<h4>Demographics</h4><table cellpadding="0" cellspacing="0" class="w100">' + ((opt_data.patient.displayRace) ? '<tr><td class="w22">Race:</td><td>' + soy.$$escapeHtml(opt_data.patient.displayRace) + '</td></tr>' : '') + ((opt_data.patient.displayEthnicity) ? '<tr><td class="w22">Ethnicity:</td><td>' + soy.$$escapeHtml(opt_data.patient.displayEthnicity) + '</td></tr>' : '') + ((opt_data.patient.preferredLanguageName) ? '<tr><td class="w22">Preferred Language:</td><td>' + soy.$$escapeHtml(opt_data.patient.preferredLanguageName) + '</td></tr>' : '') + '</table>' : '', (opt_data.patient.nokFirstName || opt_data.patient.nokLastName || opt_data.patient.nokPhone) ? '<h4>Emergency Contact</h4><table cellpadding="0" cellspacing="0" class="w100">' + ((opt_data.patient.nokFirstName || opt_data.patient.nokLastName) ? '<tr><td class="w22">Name:</td><td>' + soy.$$escapeHtml(opt_data.patient.nokFirstName ? opt_data.patient.nokFirstName : '') + ' ' + soy.$$escapeHtml(opt_data.patient.nokLastName ? opt_data.patient.nokLastName : '') + '</td></tr>' : '') + ((opt_data.patient.nokRelationship) ? '<tr><td class="w22">Relationship:</td><td>' + soy.$$escapeHtml(opt_data.patient.nokRelationship) + '</td></tr>' : '') + ((opt_data.patient.nokPhone) ? '<tr><td class="w22">Phone:</td><td>' + soy.$$escapeHtml(opt_data.patient.nokPhone) + '</td></tr>' : '') + ((opt_data.patient.nokAddress || opt_data.patient.nokCity) ? '<tr><td class="w22">Address:</td><td>' + soy.$$escapeHtml(opt_data.patient.nokAddress ? opt_data.patient.nokAddress : '') + ((opt_data.patient.nokSuite) ? ', ' + soy.$$escapeHtml(opt_data.patient.nokSuite) : '') + '<br/>' + soy.$$escapeHtml(opt_data.patient.nokCity ? opt_data.patient.nokCity : '') + ', ' + soy.$$escapeHtml(opt_data.patient.nokState ? opt_data.patient.nokState : '') + ' ' + soy.$$escapeHtml(opt_data.patient.nokZip ? opt_data.patient.nokZip : '') + '</td></tr>' : '') + '</table>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print._insurance = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table cellpadding="0" cellspacing="0" class="w100">', (opt_data.insuranceCompany) ? '<tr><td class="w15">Plan Name:</td><td>' + soy.$$escapeHtml(opt_data.insuranceCompany.carrier) + ((opt_data.insurancePlan) ? ' ' + soy.$$escapeHtml(opt_data.insurancePlan.name) : '') + '</td></tr>' : '', (opt_data.groupId) ? '<tr><td class="w15">Group Name:</td><td>' + soy.$$escapeHtml(opt_data.groupId) + '</td></tr>' : '', (opt_data.memberId) ? '<tr><td class="w15">Member No.:</td><td>' + soy.$$escapeHtml(opt_data.memberId) + '</td></tr>' : '', '</table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print.familyHistoryList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.historyItems.family.items.length || opt_data.familyRelationships.length) {
    output.append('<li class="el8ItemHeader">Family History</li>');
    var relationshipList448 = opt_data.familyRelationships;
    var relationshipListLen448 = relationshipList448.length;
    for (var relationshipIndex448 = 0; relationshipIndex448 < relationshipListLen448; relationshipIndex448++) {
      var relationshipData448 = relationshipList448[relationshipIndex448];
      var itemList449 = relationshipData448.items;
      var itemListLen449 = itemList449.length;
      for (var itemIndex449 = 0; itemIndex449 < itemListLen449; itemIndex449++) {
        var itemData449 = itemList449[itemIndex449];
        output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(relationshipData448.relationshipTypeName), ': ', soy.$$escapeHtml(itemData449.textOrCodeDescription), '</li>');
      }
    }
    var itemList457 = opt_data.historyItems.family.items;
    var itemListLen457 = itemList457.length;
    for (var itemIndex457 = 0; itemIndex457 < itemListLen457; itemIndex457++) {
      var itemData457 = itemList457[itemIndex457];
      output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(itemData457.text), '</li>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print.rowsList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.itemsList.length) {
    output.append('<li class="el8ItemHeader">', soy.$$escapeHtml(opt_data.sectionTitle), '</li>');
    el8.template.passport.print.rowsListContent(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print.rowsListContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList470 = opt_data.itemsList;
  var itemListLen470 = itemList470.length;
  for (var itemIndex470 = 0; itemIndex470 < itemListLen470; itemIndex470++) {
    var itemData470 = itemList470[itemIndex470];
    output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(itemData470.text), '</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.print.bulletedListContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList476 = opt_data.itemsList;
  var itemListLen476 = itemList476.length;
  for (var itemIndex476 = 0; itemIndex476 < itemListLen476; itemIndex476++) {
    var itemData476 = itemList476[itemIndex476];
    output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(itemData476.text), '</li>');
  }
  if (!opt_sb) return output.toString();
};
